/**
 * @generated SignedSource<<1b0293ce89c48c90ade3f36519f2230d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateWhatToSeeInput = {
  name: string;
};
export type WhatToSeeListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreateWhatToSeeInput;
};
export type WhatToSeeListAddMutation$data = {
  readonly createWhatToSee: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeListRow_whatToSee">;
    };
  };
};
export type WhatToSeeListAddMutation = {
  response: WhatToSeeListAddMutation$data;
  variables: WhatToSeeListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WhatToSeeListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WhatToSeeNode",
        "kind": "LinkedField",
        "name": "createWhatToSee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WhatToSee",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WhatToSeeListRow_whatToSee"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "WhatToSeeListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "WhatToSeeNode",
        "kind": "LinkedField",
        "name": "createWhatToSee",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WhatToSee",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "location",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "prependNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "WhatToSeeEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f4b69c8d5b0863c51e208820ed2419f5",
    "id": null,
    "metadata": {},
    "name": "WhatToSeeListAddMutation",
    "operationKind": "mutation",
    "text": "mutation WhatToSeeListAddMutation(\n  $input: CreateWhatToSeeInput!\n) {\n  createWhatToSee(input: $input) {\n    node {\n      ...WhatToSeeListRow_whatToSee\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment WhatToSeeListRow_whatToSee on WhatToSee {\n  id\n  name\n  location\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "ac9238b4fc21dce9ed76e0c582706cff";

export default node;
